import React from "react";
import { Redirect } from "react-router";
import PropTypes from "prop-types";
import { Route, Switch, withRouter } from "react-router-dom";
import { Layout, PageHeader } from "../../common/components";
import { HubPage, HubCreatePage, HubEditPage } from "./page";
import { hasRights, rights } from "../../common/utils/role-right-helper";

const HubHeader = (
  <PageHeader title="Hub" />
)

const Hub = ({ match }) => {
  if(!hasRights([rights.CanViewHub]))
    return (<Redirect to="/" />);

  return (
    <Layout PageHeader={HubHeader}>
      <Switch>
        <Route exact path={`${match.url}`} component={HubPage} />
        <Route exact path={`${match.url}/create`} component={HubCreatePage} />
        <Route exact path={`${match.url}/:id`} component={HubEditPage} /> 
      </Switch>
    </Layout>
  );
}

Hub.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
  }),
};

Hub.defaultProps = {
  match: {
    url: "",
  },
};

export default withRouter(Hub);
